import React from 'react';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { SiteHeader } from '@/routes/_layout/-components/site-header';
import { SiteFooter } from '@/routes/_layout/-components/site-footer';
export const Route = createFileRoute('/_layout')({
    component: Layout,
});
function Layout() {
    return (<div className="min-h-screen bg-background text-foreground">
            <SiteHeader />
            <Outlet />
            <SiteFooter />
        </div>);
}
